import { tw } from "@noones/ui/tw";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import { Incidents } from "./Incident";

export const PastIncidents = () => (
    <div>
        <h3 className={tw.text_h3.my_0.font_semibold}>
            <FormattedMessage {...messages.title} />
        </h3>

        <div>
            <Incidents />
        </div>
    </div>
);

const messages = defineMessages({
    title: {
        id: "PastIncidents.title",
        defaultMessage: "Past incidents",
        description: "Past incidents",
    },
});
